import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
//
import TemplateHome from "../components/TemplateHome";

//
const NotAllow = () => (
  // store

  // local

  <TemplateHome>
    <Grid container justifyContent="center">
      <Grid item>
        <Box pt={5}>
          <Typography variant="h5">
            You are not allowed to this page.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  </TemplateHome>
);
export default NotAllow;
